import { Manager } from "socket.io-client";

class SocketService {
  constructor() {
    this.manager = null;
    this.socket = null;
  }

  getOrCreateSocket(token) {
    if (!this.socket) {
      this.manager = new Manager(`${SocketService.api.baseUrl}`, {
        reconnectionDelay: 25000,
        reconnectionAttempts: Infinity,
        forceNew: true,
        reconnection: true,
        autoConnect: true,
        transports: ["websocket"],
        query: {
          token,
        },
      });

      this.socket = this.manager.socket(`${SocketService.api.path}`);
    }

    return this.socket;
  }

  disconnect() {
    this.manager?.disconnect();
    this.socket?.close();
    this.socket = null;
    this.manager = null;
  }
}

SocketService.api = {
  baseUrl: import.meta.env.VITE_APP_SOCKET_BASE_URL,
  path: "/",
};

SocketService.$displayName = "SocketService";

export default new SocketService();
